
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1320Dialog extends Serenity.EntityDialog<Report_1320Row, any> {
        protected getFormKey() { return Report_1320Form.formKey; }
        protected getIdProperty() { return Report_1320Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1320Row.localTextPrefix; }
        protected getNameProperty() { return Report_1320Row.nameProperty; }
        protected getService() { return Report_1320Service.baseUrl; }
        protected getDeletePermission() { return Report_1320Row.deletePermission; }
        protected getInsertPermission() { return Report_1320Row.insertPermission; }
        protected getUpdatePermission() { return Report_1320Row.updatePermission; }

        protected form = new Report_1320Form(this.idPrefix);

    }
}